//----------------------------------------------------------------------------
// THIS IS A GENERATED REACT ICON COMPONENT. DO NOT EDIT MANUALLY AT ANY COST!
//----------------------------------------------------------------------------;

import type { IconProps } from "../../types/icon";
import { IconWrapper } from "../IconWrapper";

export const ArrowDownLight = (allProps: IconProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IconWrapper
      componentName="ArrowDownLight"
      icon={
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M7.52302 14.842L3.27102 11.462C2.94702 11.182 2.91602 10.735 3.16602 10.441C3.41602 10.146 3.92002 10.097 4.22502 10.339L7.25002 12.745V1.725C7.25002 1.325 7.58602 1 8.00002 1C8.41402 1 8.75002 1.324 8.75002 1.724V12.745L11.775 10.339C12.08 10.097 12.577 10.152 12.835 10.441C13.099 10.739 13.034 11.222 12.729 11.463L8.47702 14.843C8.15702 15.062 7.83302 15.043 7.52302 14.843V14.842Z"
            fill="currentColor"
          />
        </svg>
      }
      {...restProps}
    />
  );
};
